import type { heicTo } from "heic-to/dist/csp/heic-to";

// isolating the dynamic import in its own module keeps heic-to's multi-MB payload lazy loaded
// (only loaded when a HEIC file is actually decoded), and allows tests to properly mock this import.
const loadHeicTo = async (): Promise<typeof heicTo> =>
  (await import("heic-to/dist/csp/heic-to")).heicTo;

export { loadHeicTo };
